import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import WordpressHostingFeatures from "../../Components/WordpressHostingFeatures";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function WordpressHosting() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Best WordPress Hosting for Security, Speed, & Reliability";
      sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
      <Helmet>
        <title>Best WordPress Hosting for Security, Speed, & Reliability</title>
        <meta name="description" content="Power your website with lightning-fast WordPress hosting. Enjoy top security, 99.9% uptime, easy setup & scalable plans-start now!" />
        <meta name="keywords" content="Wordpress Hosting, Best Wordpress Hosting, Wordpress Hosting Plans, Wordpress Website Hosting, Best Web Hosting For Wordpress, Web Hosting Wordpress, Wordpress Hosting Services, Wordpress Hosting Price, Fastest Web Hosting For Wordpress, Best Hosting Provider For Wordpress, Best Hosting Services For Wordpress" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/wordpress-hosting`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/wordpress-hosting`} />
        <meta property="og:title" content="Best WordPress Hosting for Security, Speed, & Reliability" />
        <meta property="og:description" content="Supercharge your WordPress site with safe & reliable WordPress hosting from Infinitive Host. Enjoy hassle-free site setup, expert support, etc. Get started now." />
      </Helmet>
      <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
          <div className="container">
              <div className="row g-4 align-items-center align-items-xxl-end">
                  <div className="col-lg-7">
                      <div className="d-flex align-items-center gap-2">
                          <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                          <span className="d-block fw-semibold mb-0 text-primary">
                              Wordpress Hosting That Just Works.
                          </span>
                      </div>
                      <h1 className="mb-6 text-white">
                        Your Perfect WordPress Hosting Solution
                      </h1>
                      <p className="text-white max-text-60 mb-8 text-opacity-75">
                          Are you thinking about the best WordPress hosting? Get blazing-fast speed, 24/7 support and stress-free hosting-Just for you!
                      </p>
                      <div className="d-flex align-items-center flex-wrap gap-4">
                          <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-semibold rounded btn-height">
                              <span className="btn-arrow__text">
                                  Free Trial
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </Link>
                          <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-lg fs-14 fw-semibold rounded transition btn-height">
                              <span className="btn-arrow__text">
                                  Explore
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </button>
                      <MinPlanPrice category="wordpress-hosting" />
                      </div>
                      <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                  </div>
                  <div className="col-xl-5 col-lg-5 ipad-mt">
                      <div className="about-banner__img">
                          <img src="images/your-perfect-wordpress.webp" alt="image" className="img-fluid full-width-img" />
                      </div>
                  </div>
              </div>
          </div>
      </div>

    <div className="container pt-100 pb-100">
        <div className="bg-dark pt-40 pb-40 px-8 px-md-14 rounded-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
            <div className="row align-items-center g-4">
                <div className="col-xxl-6 col-xl-4 col-lg-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <img src="images/whats-for-you-on-Infinitive-host.webp" alt="image" className="img-fluid" />
                </div>
                <div className="col-xxl-6 col-xl-8 col-lg-7">
                    <h2 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">What’s For You on Infinitive Host</h2>
                    <p className="text-white text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Offering solid security, incredibly swift performance, seamless flexibility, and 24/7 support to elevate your site flawlessly. Select your WordPress Hosting plan-scalable and engineered to fuel your growth seamlessly!</p>
                    <div className="mt-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                            <span className="d-inline-block me-1 flex-shrink-0">
                                <i className="las la-comments"></i>
                            </span>
                            <span className="btn-arrow__text">
                                Live Chat Now
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="pt-100 pb-100 cloud-hosting-points-section">
      <div className="pb-60">
          <div className="container">
            <div className="row g-4 align-items-center justify-content-xl-between">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Launch Fast. Grow Freely.</small>
                  <h2 className="mb-4">Upgrade Your Hosting Experience with One That Truly Cares</h2>
                  <p className="max-text-56 mb-0 fw-semibold">Are you still completely dependent on CPU hosting for high-performance tasks? Then, it might be the best time for an upgrade to WordPress hosting!</p>
                </div>
                <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card">
                      <div className="card-body cloud-hosting-vid-card">
                        <div className="features-video position-relative z-1"><img alt="image" className="img-fluid w-100" src="/images/wordpress-hosting-yt-banner.webp" />
                          <Link to="https://youtu.be/oJNUAlgVCSU" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                            <i className="fa-solid fa-play"></i>
                          </Link>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
      <div className="container">
          <div className="row g-4 g-md-0 feature-list">
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/faster-wordpress.webp" /></div>
                  <h6 className="mb-5">Faster WordPress Hosting</h6>
                  <p className="mb-0">Say goodbye to slow-loading web pages! Our WordPress hosting makes sure that your site loads with high speed, keeping all visitors engaged. A faster website means increased engaged users and growth opportunities.</p>
                </div>
            </div>
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/top-notch-advanced.webp" /></div>
                  <h6 className="mb-5">Top-Notch & Advanced Security</h6>
                  <p className="mb-0">Keep your site secure without stress! With timely backups, a free SSL, & an in-built security feature, your site stays secure while you emphasize what truly matters most, i.e., engagement with site visitors.</p>
                </div>
            </div>
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/refund-our.webp" /></div>
                  <h6 className="mb-5">Refund: Our Assurance</h6>
                  <p className="mb-0">Every brand works on trust, check out our service, and if it’s not a good fit, we make it the best or pay you back! Try our services & feel relaxed. If you're not satisfied within 30 days, we’ll give you a full refund.</p>
                </div>
            </div>
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/seamless-malware.webp" /></div>
                  <h6 className="mb-5">Seamless Malware Security</h6>
                  <p className="mb-0">We try our best to always keep your site protected with the help of a quick threat removal process and consistent malware scans. We make sure that your site stays highly secure and reliable for all your regular visitors.</p>
                </div>
            </div>
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/professional-web.webp" /></div>
                  <h6 className="mb-5">Professional Web Presence</h6>
                  <p className="mb-0">We usually offer a free SSL certificate & an email to help you gain trust with your visitors. Build trust and reliability with a site that’s completely secure, seamless, and skillfully engineered-because your brand demands the best.</p>
                </div>
            </div>
            <div className="col-sm-6 col-md-4 feature-list__item sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                <div className="feature-list__card border text-center">
                  <div className="mb-8"><img alt="image" className="img-fluid" src="/images/your-site-security.webp" /></div>
                  <h6 className="mb-5">Your Site Security, Our Commitment</h6>
                  <p className="mb-0">Our WordPress hosting experts are available, 24/7. Even if you want instant troubleshooting or guidance, we’re here standing by your side always, so you can focus on your site with confidence.</p>
                </div>
            </div>
          </div>
      </div>
    </div>

    <section className="price-plan-section pt-100 pb-100">
      <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
      <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-xl-8">
                      <div className="text-center">
                          <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                          <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Plan - Your Hosting</h2>
                      </div>
                  </div>
              </div>
          </div>
      </div>    
      <PlanList category={'wordpress-hosting'}/>
    </section>

    <WordpressHostingFeatures />

    <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/infinitive-host-your.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                From First Click to Final Scroll-Fast.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Infinitive Host: Your Website, Your Rules!
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                When WordPress throws an issue, relax we are always standing by you with our solutions. As the best hosting company for WordPress, our team is always available to assist you, making sure that your site stays protected and hassle-free. No pressure, just unmatched WordPress hosting!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                We Migrate, You Relax.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Flawless & Stress-Free WordPress Migration
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Switch to Infinitive Host now and get up to 30% boosted performance! Say bye-bye to hosting stress-our professional migration team guarantees a quick transfer with zero downtime so you can emphasize improving your site stress-free.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/flawless-stress-free.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
}
